module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"健康管理":"健康管理","食事":"食事","休息":"休息","運動":"運動","メンタルヘルス":"メンタルヘルス"},"en":{"健康管理":"Health management","食事":"Meals","休息":"Rest","運動":"Exercise","メンタルヘルス":"Mental health"}}')
  delete Component.options._Ctor
}
